<template>
    <div class="billing-cycle">
        <div class="form-group">
            <slider-toggle-field
                label="Billing is Recurring"
                :value="billingIsRecurring"
                data-test-id="billing-is-recurring-toggle"
                @update="$emit('recurring-update', $event)"
            ></slider-toggle-field>
        </div>
        <div class="form-group">
            <label for="start_date">Start Date</label>
            <input
                id="start_date"
                data-test-id="billing-cycle-start-date"
                type="date"
                :value="billingStartedAt"
                @change="$emit('start-date-update', $event.target.value)"
            />
        </div>
        <div
            v-if="billingIsRecurring"
            class="form-group"
        >
            <label for="renewal_date">Renewal Date</label>
            <input
                id="renewal_date"
                data-test-id="billing-cycle-renewal-date"
                type="date"
                :value="billingRenewsOn"
                required
                @change="$emit('renewal-date-update', $event.target.value)"
            />
        </div>

        <feature-toggle-field
            :availableFeatures="availableFeatures"
            :selectedFeatures="selectedFeatures"
            :userCounts="mobileFeatureUserCounts"
            :showLimits="false"
            :showUserCounts="true"
            @toggle="$emit('toggle', $event)"
            @limit-update="$emit('limit-update', $event)"
        ></feature-toggle-field>

        <div class="header"><span>Overage Allowance</span></div>
        <div class="form-group">
            <slider-toggle-field
                data-test-id="allow-overage"
                label="Allow Overage"
                name="allow_overage"
                :value="licenseOverageIsVisible"
                :isLocked="licenseOverageIsLocked"
                @lockClicked="lockedOverageToggleClicked"
                @update="
                    !licenseOverageIsLocked && $emit('license-overage-is-visible-update', !licenseOverageIsVisible)
                "
            ></slider-toggle-field>
        </div>
        <template v-if="licenseOverageIsVisible">
            <div class="form-group">
                <select
                    :value="licenseOverageType"
                    @change="$emit('license-overage-type-update', $event.target.value)"
                >
                    <option value="NUMERIC">Number</option>
                    <option value="PERCENTAGE">Percentage</option>
                </select>
            </div>
            <div class="form-group">
                <div
                    v-if="licenseOverageType === 'PERCENTAGE'"
                    class="percent-wrapper"
                >
                    <input
                        id="license_overage_amount"
                        data-test-id="license_overage_amount"
                        min="0"
                        type="number"
                        :value="licenseOverageAmount"
                        @change="licenseOverageAmountChanged"
                    />
                    <div class="percent-container">%</div>
                </div>
                <input
                    v-else
                    id="license_overage_amount"
                    data-test-id="license_overage_amount"
                    min="0"
                    type="number"
                    :value="licenseOverageAmount"
                    @change="licenseOverageAmountChanged"
                />
            </div>
        </template>
    </div>
</template>

<script>
import canConfirm from '@/mixins/canConfirm'
import FeatureToggleField from '@/components/FeatureToggleField.vue'
import SliderToggleField from '@/components/SliderToggleField.vue'

export default {
    components: {
        FeatureToggleField,
        SliderToggleField,
    },

    mixins: [canConfirm],

    props: {
        billingIsRecurring: {
            type: Boolean,
            default: false,
        },
        billingRenewsOn: {
            type: String,
            default: '',
        },
        billingStartedAt: {
            type: String,
            default: '',
        },
        licenseOverageIsVisible: {
            type: Boolean,
            default: false,
        },
        licenseOverageIsLocked: {
            type: Boolean,
            default: false,
        },
        licenseOverageAmount: {
            type: Number,
            default: null,
        },
        licenseOverageType: {
            type: String,
            default: null,
        },
        availableFeatures: {
            type: Array,
            default: () => [],
        },
        selectedFeatures: {
            type: Object,
            default: () => {},
        },
        mobileFeatureUserCounts: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        licenseOverageAmountChanged(event) {
            let value = parseInt(event.target.value, 10)

            if (Number.isNaN(value)) {
                value = 0
            }

            this.$emit('license-overage-amount-update', value)
        },

        lockedOverageToggleClicked(feature) {
            this.confirm({
                header: 'License Required',
                message:
                    'Overage requires at least 1 license. You must purchase additional licenses ' +
                    'before setting an overage allowance.',
                acceptLabel: 'OK',
                // Nothing to decline: this only tells the user why they cannot proceed.
                rejectLabel: null,
            })
        },
    },
}
</script>

<style scoped lang="scss">
.billing-cycle {
    input,
    select {
        width: 186px;
    }
}

.header {
    align-self: end;
    margin-top: 16px;
    margin-bottom: 16px;
    span {
        font-family: 'Avenir Heavy';
        font-size: 0.9125em;
        color: #999;
    }
}

.valuePadding {
    width: 186px;
    color: black;
    background-color: white;
    height: 36px;
}

.valuePadding input {
    border: none;
    padding: 0px;
    outline: none;
    text-align: left;
    width: 150px;
}

.percent-wrapper {
    display: flex;
    height: 36px;
    width: 186px;
    align-items: baseline;

    input {
        width: 161px;
    }

    .percent-container {
        background-color: white;
        color: black;
        height: 100%;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: -5px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}
</style>
